import React, { useState } from "react";
import moment from "moment";
import TextInputField from "../../../Shared/TextInputField";
import Button from "../../../Shared/Button";
import { fetchAppointmentReport } from "../../../../services/report";
import * as csv from "fast-csv";
import useReportData from "../useReportData";

const AppointmentReport = () => {
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));

  const { isLoading, failureReason, info, isEmpty, scheduleLoad, loadNow, download } = useReportData({
    cacheKey: date,
    isReady: Boolean(date),
    fileName: `SESSION SCHEDULE REPORT_${date}.csv`,
    infoMessage: `Preparing session schedule report(${date})...`,
    emptyMessage: "No available workflows in given range",
    loadCsv: async () => {
      const columnsNamingMap = {
        URN: "URN",
        type: "Type",
        patientName: "Patient Name",
        patientDOB: "DOB",
        specialist: "Specialist",
        speciality: "Speciality",
        appointmentStartDate: "Appt Start Date",
        appointmentStartTime: "Appt Start Time",
        location: "Location",
        newOrReview: "New/Review",
        appointmentNotes: "Appointment Notes",
        videoLink: "Video Link",
      };
      const { data: reportRawData } = await fetchAppointmentReport({ date });
      if (!reportRawData?.length) {
        return { rowCount: 0 };
      }
      const rows = [Object.keys(reportRawData[0]).map((key) => columnsNamingMap[key] || key)].concat(
        reportRawData.map((data) => Object.values(data).map((a) => a.toString()))
      );
      return { csv: await csv.writeToString(rows), rowCount: reportRawData.length };
    },
  });

  return (
    <>
      <p className="menu-label">Session Schedule Report</p>
      <div className="columns">
        <div className="column is-one-quarter">
          <TextInputField
            label="Date"
            isRequired={true}
            hasError={false}
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
              scheduleLoad();
            }}
            onBlur={loadNow}
            placeholder={moment().format("YYYY-MM-DD")}
            type="date"
          />
        </div>
      </div>
      <p className="has-text-danger is-size-7">{failureReason}</p>
      <p className="has-text-info is-size-7">{info}</p>
      <Button
        isFullWidth={false}
        disabled={!date || isLoading || isEmpty}
        isLoading={isLoading}
        onClick={download}
        text="Download"
      />
    </>
  );
};

export default AppointmentReport;
